import { Box } from '@mui/material';
import { formatISO, isSameDay, isValid, parseISO } from 'date-fns';
import React from 'react';
import { DatePicker } from '../DatePicker';
import { TimePicker } from '../TimePicker';
export const DateTimePicker = (props) => {
    var _a;
    const dateValue = getDateValue(props.value);
    const timeValue = getTimeValue(props.value);
    const handleDateChange = (newDateValue) => {
        props.onChange({
            date: makeDate(newDateValue, timeValue),
            dateValue: newDateValue,
            timeValue: timeValue,
        });
    };
    const handleTimeChange = (newTimeValue) => {
        props.onChange({
            date: makeDate(dateValue, newTimeValue),
            dateValue: dateValue,
            timeValue: newTimeValue,
        });
    };
    const rootSx = {
        display: 'flex',
        flexDirection: props.display === 'column' ? 'column' : 'row',
        gap: 2,
    };
    let childSx = undefined;
    if (props.fullWidth) {
        rootSx.width = '100%';
        childSx = { flexGrow: 1, flexBasis: 0 };
    }
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, rootSx), props.sx) },
        React.createElement(DatePicker, { sx: childSx, label: props.dateLabel, minDate: getMinDate(props.minDate), maxDate: getMaxDate(props.maxDate), required: props.required, disabled: props.disabled, readOnly: props.readOnly, fullWidth: props.fullWidth, size: props.size, error: props.error, tabIndex: props.dateTabIndex, value: dateValue, onChange: handleDateChange, "data-test": props['data-test-date'], autoFocus: (_a = props.autoFocus) !== null && _a !== void 0 ? _a : false }),
        React.createElement(TimePicker, { sx: childSx, label: props.timeLabel, minTime: getMinTime(dateValue, props.minDate), maxTime: getMaxTime(dateValue, props.maxDate), timeFormat: props.timeFormat, timeMinuteStep: props.timeMinuteStep, required: props.required, disabled: props.disabled, readOnly: props.readOnly, fullWidth: props.fullWidth, size: props.size, error: props.error, tabIndex: props.timeTabIndex, value: timeValue, onChange: handleTimeChange, "data-test": props['data-test-time'] })));
};
function getDateValue(value) {
    if (value.dateValue) {
        return value.dateValue;
    }
    else if (value.date) {
        if (isValid(value.date)) {
            return { date: formatISO(value.date, { representation: 'date' }) };
        }
        else {
            return { invalidDate: value.date };
        }
    }
    else {
        return {};
    }
}
function getTimeValue(value) {
    if (value.timeValue) {
        return value.timeValue;
    }
    else if (value.date) {
        if (isValid(value.date)) {
            return { time: getTimeValueFromDate(value.date) };
        }
        else {
            return {};
        }
    }
    else {
        return {};
    }
}
function getMinDate(minDate) {
    if (minDate && isValid(minDate)) {
        return formatISO(minDate, { representation: 'date' });
    }
    else {
        return undefined;
    }
}
function getMaxDate(maxDate) {
    if (maxDate && isValid(maxDate)) {
        return formatISO(maxDate, { representation: 'date' });
    }
    else {
        return undefined;
    }
}
function getMinTime(dateValue, minDate) {
    if (minDate && isValid(minDate) && dateValue.date) {
        if (isSameDay(minDate, parseISO(dateValue.date))) {
            return getTimeValueFromDate(minDate);
        }
        return undefined;
    }
    else {
        return undefined;
    }
}
function getMaxTime(dateValue, maxDate) {
    if (maxDate && isValid(maxDate) && dateValue.date) {
        if (isSameDay(maxDate, parseISO(dateValue.date))) {
            return getTimeValueFromDate(maxDate);
        }
        return undefined;
    }
    else {
        return undefined;
    }
}
function makeDate(dateValue, timeValue) {
    if (dateValue.date && typeof timeValue.time === 'number') {
        const dateWithoutTime = parseISO(dateValue.date);
        if (isValid(dateWithoutTime)) {
            return new Date(dateWithoutTime.getTime() + timeValue.time);
        }
    }
    return undefined;
}
function getTimeValueFromDate(date) {
    return date.getHours() * 60 * 60 * 1000 + date.getMinutes() * 60 * 1000 + date.getSeconds() * 1000 + date.getMilliseconds();
}
